export const columnHeader = [
  {
    key: 'customerId', name: ''
  },
  {
    key: 'registered', name: ''
  },
  {
    key: 'products', name: ''
  },
  {
    key: 'status', name: 'Status'
  },
  {
    key: 'moreoptions', name: 'Options'
  },
];

export const userAuditLogs = [
  {
    key: 'action', name: 'Action', width: "50%",
  },
  {
    key: 'channel', name: 'Channel', width: "25%",
  },
  {
    key: 'timestamp', name: 'Timestamp', width: "25%",
  }
];

export const productHeaders = [
  {
    name: 'Product', width: "15%",
  },
  {
    name: 'Created On', width: "15%",
  },
  {
    name: 'Renewal', width: "25%",
  },
  {
    name: 'Amount', width: "20%",
  },
  {
    name: 'Status', width: "20%",
  },
];

export const subscriptionHeaders = [
  {
    name: 'Subscription ID', width: "5%",
  },
  {
    name: 'Product', width: "15%",
  },
  {
    name: 'Subscribed On', width: "15%",
  },
  {
    name: 'Valid Till', width: "25%",
  },
  {
    name: 'Amount', width: "20%",
  },
  {
    name: 'Status', width: "20%",
  },
];
